import { combineLoaders } from '@/lib/loader/combine-loader';
import { permissionsLoader } from '@/lib/loader/permission-loader';
import { lazy } from 'react';
import { FeatureFlagKey } from '@/features/feature-flag/feature-flag.constants';
import { withFeature } from '@/features/feature-flag/components/with-feature';

const SmartPricingPage = lazy(
  () => import('./pages/smart-pricing/legacy-page')
);
const SmartPricingV2Page = lazy(() => import('./pages/smart-pricing'));
const CouponsPage = lazy(() => import('./pages/coupons'));
const CouponFormPage = lazy(() => import('./pages/coupons/form'));
const GiftCardsPage = lazy(() => import('./pages/gift-cards'));
const GiftCardFormPage = lazy(() => import('./pages/gift-cards/form'));

export const pricingeRoute = [
  {
    path: '/pricing/coupons',
    Component: withFeature(FeatureFlagKey.MODULE_COUPONS, CouponsPage),
    loader: combineLoaders(permissionsLoader),
  },
  {
    path: '/pricing/coupons/form',
    Component: withFeature(FeatureFlagKey.MODULE_COUPONS, CouponFormPage),
    loader: combineLoaders(permissionsLoader),
  },
  {
    path: '/pricing/coupons/form/:id',
    Component: withFeature(FeatureFlagKey.MODULE_COUPONS, CouponFormPage),
    loader: combineLoaders(permissionsLoader),
  },
  {
    path: '/pricing/gift-cards',
    Component: withFeature(FeatureFlagKey.MODULE_GIFT_CARDS, GiftCardsPage),
    loader: combineLoaders(permissionsLoader),
  },
  {
    path: '/pricing/gift-cards/form',
    Component: withFeature(FeatureFlagKey.MODULE_GIFT_CARDS, GiftCardFormPage),
    loader: combineLoaders(permissionsLoader),
  },
  {
    path: '/pricing/gift-cards/form/:id',
    Component: withFeature(FeatureFlagKey.MODULE_GIFT_CARDS, GiftCardFormPage),
    loader: combineLoaders(permissionsLoader),
  },
  {
    path: '/pricing/smart-pricing',
    Component: withFeature(
      FeatureFlagKey.MODULE_SMART_PRICING,
      SmartPricingPage
    ),
    loader: combineLoaders(permissionsLoader),
  },
  /* the Availability design (ELI-419), next to the old page while it rolls out */
  {
    path: '/pricing/smart-pricing-v2',
    Component: withFeature(
      FeatureFlagKey.MODULE_SMART_PRICING,
      withFeature(
        FeatureFlagKey.RELEASE_PRICING_SMART_PRICING,
        SmartPricingV2Page
      )
    ),
    loader: combineLoaders(permissionsLoader),
  },
];
